import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export const fieldBoxRootSx: SxProps<Theme> = (theme) => ({
  boxSizing: 'border-box',
  py: 0.5,
  pl: '13px',
  pr: 1,
  borderRadius: '3px',
  bgcolor: 'background.paper',
  boxShadow: `0px 1px 4px ${alpha(theme.palette.common.black, 0.15)}`,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '38px',
  letterSpacing: theme.typography.body1.letterSpacing ?? '0em',
  minHeight: '38px',
  maxWidth: 758,
  width: '100%',
});

export const fieldBoxInnerSx: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
